<template>
<!--  <el-header>-->
  <div class="my-header-menu">
    <div class="my-header-menu-logo">
      <a style="cursor: pointer;font-size: 18px;font-weight: bolder;color: #fff;" @click="routerTo('/')">
<!--        GameBrain自动化素材系统-->
        <img src="../../assets/logo.png" />
      </a>
    </div>
    <div class="my-header-menu-list">
      <div class="menu_item" v-for="(menu_item,menu_key) in $store.state.menu" v-if="menu_item.is_show===1" :key="menu_key">
        <a style="cursor: pointer" @click="routerTo(menu_item.url)">{{menu_item.name}}</a>
        <div class="menu_item_collapse" v-if="menu_item.child">
          <el-row class="menu_item_collapse_content">
            <el-col :span="4" class="menu_item_collapse_child" v-for="(menu_item_item,menu_item_key) in menu_item.child" v-if="menu_item_item.is_show===1" :key="menu_item_key">
              <a style="cursor: pointer" @click="routerTo(menu_item_item.url)">
                <i :class="menu_item_item.icon" style="margin-right: 5px;"></i>
                {{menu_item_item.name}}
              </a>
              <ul v-if="menu_item_item.child">
                <li v-for="(menu_item_item_item,menu_item_item_key) in menu_item_item.child" v-if="menu_item_item_item.is_show===1" :key="menu_item_item_key">
                  <a style="cursor: pointer" @click="routerTo(menu_item_item_item.url)">
                    {{menu_item_item_item.name}}
                  </a>
                </li>
              </ul>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
    <div class="my-header-menu-user">
      <el-dropdown v-if="$store.state.user_info.name" style="float: right">
        <span class="el-dropdown-link" style="color: #ffffff">
          {{$store.state.user_info.name}}<i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item @click.native="routerTo('/user/user_info')">个人资料</el-dropdown-item>
          <el-dropdown-item @click.native="routerTo('/user/update_password')">修改密码</el-dropdown-item>
          <el-dropdown-item @click.native="changeUpload">{{uploadType}}</el-dropdown-item>
          <el-dropdown-item @click.native="outLogin">退出</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <a v-else style="cursor: pointer" @click="routerTo('/login')">LOGIN</a>
    </div>
  </div>
</template>

<script>
	import {OutLogin} from "../../api/user";

  export default {
		name: "HeaderMenu",
    data(){
		  return {
        uploadType:'线上',
      }
    },
    mounted() {
		  if (localStorage.getItem('is_int')){
		    this.uploadType = '线下'
      }
    },
    methods:{
      changeUpload(){
        if (localStorage.getItem('is_int')){
          localStorage.setItem('is_int',false)
        }else{
          localStorage.setItem('is_int',true)
        }
      },
      routerTo(url){
        if (url!==""){
          this.$router.push({ path: url }).catch(err => err)
        }
      },
      outLogin(){
        OutLogin({}).then(resp => {
          if (resp.code===200){
            this._set_login('','')
            this.$message.success(resp.message)
            window.location = '/'
          }
        })
      }
    },
  }
</script>

<style scoped>
  .my-header-menu{
    width: 1200px;
    height: 100%;
    margin: 0 auto;
  }
  .my-header-menu-logo{
    width: 200px;
    height: 100%;
    text-align: center;
    line-height: 60px;
    float: left;
  }
  .my-header-menu-logo img{
    height: 80%;
    vertical-align: middle;
  }
  .my-header-menu-list{
    width: 800px;
    height: 100%;
    float: left;
  }
  .menu_item{
    width: 100px;
    height: 100%;
    float: left;
    line-height: 60px;
    text-align: center;
    color: #C0C4CC;
    font-size: 15px;
    cursor: pointer;
  }
  .menu_item_collapse{
    left: 0;
    top: 60px;
    width: 100%;
    position: absolute;
    z-index: 99;
    background: #0a1e39;
    display: none;
  }
  .menu_item_collapse_content{
    width: 800px;
    margin: 0 auto;
  }
  .menu_item_collapse_child {
    color: #ffffff;
    text-align: left;
    line-height: 40px;
    font-size: 16px;
    font-weight: bolder;
  }
  .menu_item_collapse_child ul{
    list-style-type: none;
    line-height: 30px;
    font-size: 14px;
    font-weight: normal;
    margin: 0;
    padding: 0;
    margin-left: 25px;
  }
  .menu_item:hover .menu_item_collapse{
    display: block;
  }
  .menu_item:hover{
    color: #fff;
    opacity:1;
  }
  .my-header-menu-user{
    width: 200px;
    height: 100%;
    float: left;
    color: #C0C4CC;
    font-size: 14px;
    line-height: 60px;
  }
  .el-dropdown-link {
    color: #C0C4CC;
    cursor: pointer;
  }
  .el-icon-arrow-down {
    font-size: 12px;
  }
</style>



// WEBPACK FOOTER //
// src/components/header/HeaderMenu.vue